<template>
  <div class="cw-mb-3">
    <label for="country-selector"
      class="cw-font-semibold cw-text-sm">{{ $t('enabled-locations-map.select-country') }}</label>
    <select id="country-selector"
      class="form-select cw-block cw-appearance-none cw-w-full cw-py-1 cw-px-2 cw-mb-1 cw-text-base cw-leading-normal cw-bg-white cw-text-gray-800 cw-border cw-border-gray-200 cw-rounded"
      @change="handleSelect">
      <option value="allCountries">
        {{ $t('enabled-locations-map.all-countries') }}
      </option>
      <option v-for="country in countryList"
        :key="country"
        :value="country.toLowerCase()"
        :selected="selectedCountry === country.toLowerCase()">
        {{ country }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'CountrySelector',

  props: {
    countryList: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedCountry: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      selected: '',
    }
  },

  methods: {
    handleSelect(event) {
      this.$emit('updateFilter', {
        key: 'filterCountryValue',
        value: event.target.value,
      })
    },
  },
}
</script>

<style scoped>
.form-select {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAABGdBTUEAALGPC/xhBQAAAQtJREFUOBG1lEEOgjAQRalbGj2OG9caOACn4ALGtfEuHACiazceR1PWOH/CNA3aMiTaBDpt/7zPdBKy7M/DCL9pGkvxxVp7KsvyJftL5rZt1865M+Ucq6pyyF3hNcI7Cuu+728QYn/JQA5yKaempxuZmQngOwEaYx55nu+1lQh8GIatMGi+01NwBcEmhxBqK4nAPZJ78K0KKFAJmR3oPp8+Iwgob0Oa6+TLoeCvRx+mTUYf/FVBGTPRwDkfLxnaSrRwcH0FWhNOmrkWYbE2XEicqgSa1J0LQ+aPCuQgZiLnwewbGuz5MGoAhcIkCQcjaTBjMgtXGURMVHC1wcQEy0J+Zlj8bKAnY1/UzDe2dbAVqfXn6wAAAABJRU5ErkJggg==');
    background-size: 0.7rem;
    background-position: right 0.7rem center;
    background-repeat: no-repeat;
  }
</style>
